/**
 * The session cannot be refreshed: nothing to refresh with, or the token endpoint rejected the request (400/401 —
 * e.g. invalid_grant for an expired or revoked refresh token). Any other refresh error is treated as temporary.
 * Also thrown by OAuthTokenStore.getAccessToken when its proactive refresh is rejected, so AuthService can sign out.
 */
export class SessionRefreshRejectedError extends Error {
    constructor (message: string) {
        super(message)
        this.name = 'SessionRefreshRejectedError'
    }
}
